import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Select from "react-select";
import useSWR from "swr";
import useAuth from "../../../../initialpage/hooks/useAuth";
import { API } from "../../StoreComponents/conflict";
import "../../StoreComponents/storeStyle.css";
import Cookies from "js-cookie";
const fetcher1 = (url) =>
  API.get(url, {
    headers: {
      search: `%%`,
    },
  }).then((res) => res.data.data);
const fetcher = (url) => API.get(url).then((res) => res.data.data);
const ProductWiseReport = () => {
  const user = JSON.parse(Cookies.get("user") || '{}');
  const employee_id = user?.employe_id;
  const [selectedProduct, setSelectedProduct] = useState({});
  const [printButton, setPrintButton] = useState(false);
  const [yearDate, setYearDate] = useState("");
  const [typeError, setTypeError] = useState("");
  const [openElement, setOpenElement] = useState(false);
  // get UserReport Data
  const {
    data: UserReport,
    error,
    mutate,
  } = useSWR(
    employee_id && selectedProduct && yearDate
      ? `store/reports/user/requisitions/product?hrid=${employee_id}&proid=${selectedProduct.value}&year=${yearDate}`
      : null,
    fetcher
  );

  console.log(UserReport);

  // get year select Data
  let presentYear = new Date().getFullYear();
  let yearMap = [];
  for (let i = 2022; i <= presentYear; i++) {
    yearMap.push(i);
  }
  // toggle seach button
  const handleToggle = () => {
    if (!openElement) {
      setOpenElement(true);
    } else {
      setOpenElement(false);
    }
  };

  const { data: productOption, error: error3 } = useSWR(
    `store/products/storeProducts?page=${0}&limit=${10000}`,
    fetcher1
  );
  console.log(productOption);
  // set Product select list
  let productCategory = [];
  if (productOption && productOption.length > 0) {
    productCategory = productOption.map((data) => {
      let optionsItem = {};
      optionsItem.value = data.PROID;
      optionsItem.label = `${data.PRONAME} - ${data.PRONAMETWO}`;
      return optionsItem;
    });
  }

  const handleProduct = (product) => {
    setSelectedProduct(product);
  };

  console.log(UserReport);

  return (
    <>
      <Helmet>
        <title>Reports - BBA STORE</title>
        <meta name="description" content="Reports - BBA STORE" />
      </Helmet>
      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important}"
        }
      </style>

      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h3 className="text-start text-dark">
              BBA Store Requisition Reports
            </h3>
          </div>
          <div
            style={{ background: "white", borderRadius: "10px" }}
            className="p-3"
          >
            <div className="add_category text-center">
              <div className="row mx-3">
                <div className="col-12 col-md-6 col-lg-6">
                  <label htmlFor="product_name">
                    Product Name <span className="color-red">*</span>
                  </label>
                  <Select
                    onChange={handleProduct}
                    style={{ borderRadius: "10px" }}
                    className="text-start fs-6"
                    options={productCategory}
                  />
                  <p className="text-start text-danger">
                    {selectedProduct.value ? "" : typeError}
                  </p>
                </div>

                <div className="col-12 col-md-6 col-lg-6">
                  <label htmlFor="To_Date">Year</label>
                  <select
                    className="form-select input-field-existing fs-6"
                    aria-label="Default select example"
                    onChange={(e) => {
                      setYearDate(e.target.value);
                    }}
                  >
                    <option value="">select Year</option>
                    {yearMap &&
                      yearMap.map((product) => (
                        <option value={product}>{product}</option>
                      ))}
                  </select>
                </div>
              </div>
              <br />
              <button
                onClick={handleToggle}
                type="button"
                className="mt-3 btn-color_store px-5 btn "
              >
                <i className="fa fa-search"></i>
                <span> Search</span>
              </button>
            </div>

            <div
              className={
                openElement
                  ? "category show mb-3 table-container p-2"
                  : "category my-4 table-container p-2"
              }
              style={{ background: "white", borderRadius: "10px" }}
            >
              <div className="row mt-5">
                <div className="col-12">
                  <div className="table-responsive-sm storeTableFont">
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr className="text-center tableColor">
                          <th>S/N</th>
                          <th>DATE & TIME</th>
                          <th>PRODUCT NAME</th>

                          <th>REQUEST QTY</th>
                          <th>APPROVE QTY</th>
                          {/* <th>YEAR</th> */}
                          <th>PREMARKS</th>
                        </tr>
                      </thead>
                      {UserReport && (
                        <tbody>
                          {UserReport.map((product, index) => (
                            <tr className="text-center" key={index}>
                              <td>{++index}</td>
                              <td>{product.PRODATE}</td>
                              <td>{product.PRONAME} </td>

                              <td>{product.PROREQUQTY}</td>
                              <td>{product.APROQTY}</td>
                              {/* <td>{product.YEAR}</td> */}
                              <td>{product.PREMARKS}</td>
                            </tr>
                          ))}
                        </tbody>
                      )}
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductWiseReport;
